import { useBrandPerformanceDashboardEmbedInfo } from "@/hooks/use-brand-performance-dashboard-embed-info";
import { DashboardEmbedPage } from "./dashboard-embed-page";

interface BrandPerformancePageProps {
  theme: "dark" | "light";
}

export function BrandPerformancePage(props: BrandPerformancePageProps) {
  const embedInfoQuery = useBrandPerformanceDashboardEmbedInfo();

  return (
    <DashboardEmbedPage
      description="View brand performance insights"
      embedInfoQuery={embedInfoQuery}
      theme={props.theme}
      title="Brand Performance"
    />
  );
}
